var icon = require('vue-svgicon')
icon.register({
  'ks-icon-primary-contact': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M74.8 52.84H55.22v9.91H74.8a5.19 5.19 0 0 0 3.09-.66 2.75 2.75 0 0 0 .84-2.31v-4a2.74 2.74 0 0 0-.84-2.28 5.2 5.2 0 0 0-3.09-.66z"/><path pid="1" d="M63.88 22.84a41.23 41.23 0 1 0 41.23 41.23 41.22 41.22 0 0 0-41.23-41.23zM87.12 62c0 2.53-.67 4.36-2 5.51s-3.49 1.71-6.46 1.71H55.22v14.56h-8.57V46.36h32q4.45 0 6.46 1.71t2 5.55z"/>'
  }
})
